<template>
  <b-container>
    <v-form ref="form" v-model="valid">
      <!-- ROW 0-->
      <b-row>
        <!-- Buscador-->
        <b-col>
          <h2 v-if="(!bloqueado) && (modo==='crear')">{{$t('domicilios.formulario.crearDireccion')}}</h2>
          <h2
            v-if="(!bloqueado) && (modo==='actualizar')"
          >{{$t('domicilios.formulario.actualizarDireccion')}}</h2>
          <h2
            v-if="(!bloqueado) && (modo==='seleccionar') && (esDirOrigen)"
          >{{$t('domicilios.formulario.datosRemitente')}}</h2>
          <h2
            v-if="(!bloqueado) && (modo==='seleccionar') && (!esDirOrigen)"
          >{{$t('domicilios.formulario.datosDestinatario')}}</h2>
        </b-col>
        <b-col v-if="(!recogerEnCliente)&&(modo!=='crear')">
          <v-autocomplete
            v-if="(!bloqueado)"
            v-model="selectedAddress"
            :items="addresses"
            :label="$t('domicilios.formulario.seleccionaDireccion')"
            prepend-icon="mdi-city"
            :filter="customFilter"
            return-object
            :input="estableSituacion()"
            browser-autocomplete="off"
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select"
                @input="clear"
              >{{data.item.Codigo}} - {{data.item.Nombre}}</v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <v-content v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </v-content>
              <v-content v-else>
                <v-layout row wrap>
                  <v-flex xs3>{{data.item.Codigo}}</v-flex>
                  <v-flex xs9>
                    <v-list-tile-content>
                      <v-list-tile-title>{{data.item.Nombre}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{data.item.Poblacion}} - {{data.item.Direccion}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-flex>
                </v-layout>
              </v-content>
            </template>
          </v-autocomplete>
        </b-col>
      </b-row>

      <!-- ROW 1-->
      <b-row v-if="!recogerEnCliente">
        <!-- Código-->
        <b-col>
          <b-form-group label=" " label-for="street">
            <v-text-field
              :label="$t('domicilios.formulario.codigo')"
              :readonly="bloqueado"
              v-model="selectedAddress.Codigo"
            ></v-text-field>
          </b-form-group>
        </b-col>
        <b-col></b-col>
        <b-col></b-col>
      </b-row>
      <!-- ROW 2-->
      <b-row>
        <!-- Nombre y apellido -->
        <b-col md="5">
          <b-form-group label=" " label-for="street">
            <v-text-field
              :label="$t('domicilios.formulario.nombreApellidos')"
              ref="NombreApellido"
              :readonly="bloqueado"
              v-model="selectedAddress.Nombre"
              :rules="validations.standarRules"
            ></v-text-field>
          </b-form-group>
        </b-col>

        <!-- EMAIL -->
        <b-col md="3">
          <b-form-group label=" " label-for="street">
            <v-text-field
              label="Email"
              :readonly="bloqueado"
              v-model="selectedAddress.Email"
              required
              :rules="validations.emailRules"
            ></v-text-field>
          </b-form-group>
        </b-col>

        <!-- Número de telefono -->
        <b-col md="2">
          <b-form-group label=" " label-for="street">
            <v-text-field
              :label="$t('domicilios.formulario.telefono')"
              :readonly="bloqueado"
              v-model="selectedAddress.Telefono"
            ></v-text-field>
          </b-form-group>
        </b-col>

        <!-- NIF -->
        <b-col md="2">
          <b-form-group label=" " label-for="street">
            <v-text-field label="NIF" :readonly="bloqueado" v-model="selectedAddress.Nif"></v-text-field>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- ROW 3-->
      <b-row>
        <!-- País / Región-->
        <b-col md="2">
          <v-autocomplete
            v-model="selectedAddress.Pais"
            :loading="loading"
            :items="paises"
            hide-no-data
            hide-details
            :label="$t('domicilios.formulario.pais')"
            :rules="validations.standarRules"
            @change="limpiarDireccion(), filtrarAPI()"
            @input="$refs.autocompleteCodigoPostal.focus()"
            @click:clear="filtrarAPI()"
          ></v-autocomplete>
        </b-col>
        <!-- CodigoPostal -->
        <b-col md="2">
          <v-autocomplete
            ref="autocompleteCodigoPostal"
            v-model="selectedAddress.CodigoPostal"
            :loading="loading"
            :items="CodigosPostales"
            hide-no-data
            hide-details
            :search-input.sync="CodigoPostal_s"
            :label="$t('domicilios.formulario.codigoPostal')"
            @change="filtrarAPI()"
            @input="$refs.autocompletePoblacion.focus()"
            @click:clear="filtrarAPI()"
            :rules="validations.codigoPostal"
            @keydown.enter="focusPoblacion"
            tabindex="0"
            v-if="paisCercano"
          ></v-autocomplete>
          <v-text-field
            :label="$t('domicilios.formulario.codigoPostal')"
            v-if="!paisCercano"
            v-model="selectedAddress.CodigoPostal"
          ></v-text-field>
        </b-col>
        <!-- Poblacion -->
        <b-col md="4">
          <v-autocomplete
            tabindex="0"
            ref="autocompletePoblacion"
            v-model="selectedAddress.Poblacion"
            :loading="loading"
            :items="Poblaciones"
            hide-no-data
            menu-props="openOnHover"
            hide-details
            :search-input.sync="Poblacion_s"
            :label="$t('domicilios.formulario.poblacion')"
            @change="filtrarAPI()"
            @input="$refs.autocompleteProvincia.focus()"
            @click:clear="filtrarAPI()"
            :rules="validations.standarRules"
            v-if="paisCercano"
          ></v-autocomplete>
          <v-text-field
            ref="textFieldPoblacion"
            :label="$t('domicilios.formulario.poblacion')"
            v-if="!paisCercano"
            :rules="validations.standarRules"
            v-model="selectedAddress.Poblacion"
          ></v-text-field>
        </b-col>
        <!-- Provincia -->
        <b-col md="2">
          <v-autocomplete
            ref="autocompleteProvincia"
            v-model="Provincia"
            :loading="loading"
            :items="Provincias"
            hide-no-data
            hide-details
            :search-input.sync="Provincia_s"
            :label="$t('domicilios.formulario.provincia')"
            readonly
            @change="filtrarAPI()"
            @input="$refs.TextFieldDireccion.focus()"
            @click:clear="filtrarAPI()"
          ></v-autocomplete>
        </b-col>
        <!-- Comunidad -->
        <b-col md="2" v-if="false">
          <v-autocomplete
            v-model="Comunidad"
            :loading="loading"
            :items="Comunidades"
            hide-no-data
            hide-details
            :search-input.sync="Comunidad_s"
            label="Comunidad"
            @change="filtrarAPI()"
            @click:clear="filtrarAPI()"
          ></v-autocomplete>
        </b-col>

        <b-col md="1">
          <v-btn :loading="loading" @click="limpiarDireccion">Limpiar</v-btn>
        </b-col>
      </b-row>
      <!-- ROW 4-->
      <b-row>
        <!-- Dirección postal-->
        <b-col>
          <b-form-group label=" " label-for="street">
            <v-text-field
              ref="TextFieldDireccion"
              :label="$t('domicilios.formulario.direccion')"
              :readonly="(bloqueado)"
              v-model="selectedAddress.Direccion"
              :rules="validations.standarRules"
            ></v-text-field>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- ROW 8 -->
      <b-row>
        <b-col>
          <!-- OBSERVACIONES  -->
          <b-form-group center id="observations" label=" " label-for="observations">
            <v-textarea
              :label="$t('domicilios.formulario.observaciones')"
              v-model="selectedAddress.Observacion"
              :readonly="bloqueado"
            ></v-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- ROW 9 -->
      <b-row class="hidden-sm-and-down">
        <!-- SUBMIT  -->
        <v-layout>
          <v-flex>
            <v-btn
              flat
              @click="dialogCancel=true"
              v-if="modo!=='seleccionar'"
            >{{$t('otros.cancelar')}}</v-btn>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              v-if="(!bloqueado && !recogerEnCliente)"
              :disabled="(!valid || !selectedAddress.Codigo)"
              color="success"
              @click="validate"
            >
              <v-icon dark>save</v-icon>
              {{selectedAddress.Id?$t('otros.modificar'):$t('otros.guardar')}} {{$t('domicilios.formulario.direccionHabitual')}}
            </v-btn>
          </v-flex>
        </v-layout>
      </b-row>

      <b-row class="hidden-md-and-up">
        <v-btn flat @click="dialogCancel=true" v-if="modo!=='seleccionar'">{{$t('otros.cancelar')}}</v-btn>
      </b-row>

      <b-row class="hidden-md-and-up">
        <v-btn
          v-if="(!bloqueado && !recogerEnCliente)"
          :disabled="(!valid || !selectedAddress.Codigo)"
          color="success"
          @click="validate"
        >
          <v-icon dark>save</v-icon>
          {{selectedAddress.Id?$t('otros.modificar'):$t('otros.guardar')}} {{$t('domicilios.formulario.direccionHabitual')}}
        </v-btn>
      </b-row>
    </v-form>

    <v-dialog v-model="dialogCancel" width="400px">
      <cancelar-modal @cerrar="dialogCancel=false" />
    </v-dialog>
  </b-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import queryString from "query-string";
import CancelarModal from "../CancelarModal";

export default {
  name: "address-Form",
  components: { CancelarModal },
  created: function() {
    this.options = this.$store.state.addresses.direcciones;
    this.selectedAddress = JSON.parse(JSON.stringify(this.direccion)); //Copia sin referencia
  },
  async mounted() {
    await this.fetchCountries();
    this.selectedAddress.Nombre = this.direccion.Nombre;
    this.filtrarAPI();
    if (this.modo === "seleccionar" && this.nuevoServicio && !this.esDirOrigen)
      this.clear();
    if (this.modo === "crear") this.clear();
  },
  props: {
    direccion: {
      type: Object,
      required: true
    },
    esDesdeServicio: {
      type: Boolean,
      default: false
    },
    bloqueado: {
      type: Boolean,
      default: false
    },
    recogerEnCliente: {
      type: Boolean,
      default: false
    },
    modo: {
      type: String,
      default: "seleccionar" //crear actualizar
    },
    nuevoServicio: {
      type: Boolean,
      required: false,
      default: false
    },
    esDirOrigen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      valid: true,

      dialogCancel: false,
      loading: false,
      error: null,
      options: {},
      selectedAddress: {},
      isEditing: false,
      title: "Añadir una nueva dirección",
      direccionSubmit: "Guardar",
      Comunidades: [],
      Comunidad: "",
      Provincias: [],
      Provincia: "",
      Poblaciones: [],
      CodigosPostales: [],

      Provincia_s: "",
      Comunidad_s: "",
      Poblacion_s: "",
      CodigoPostal_s: "",

      validations: {
        emailRules: [
          //v => !!v || "E-mail necesario",
          v =>
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) ||
            /^$/.test(v) ||
            "E-mail no válido"
        ],
        standarRules: [v => !!v || "Campo necesario"],
        codigoPostal: [
          v =>
            this.codigoPostalNecesario(v) ||
            "Código Postal obligatorio en este país"
        ]
      }
    };
  },
  methods: {
    codigoPostalNecesario(v) {
      if (v) return true;
      if (!this.selectedAddress.Pais) return false;
      if (
        this.selectedAddress.Pais !== "ESPAÑA" &&
        this.selectedAddress.Pais !== "ANDORRA" &&
        this.selectedAddress.Pais !== "PORTUGAL"
      )
        return true;
      return false;
    },
    customFilter(item, queryText, itemText) {
      const Codigo = item.Codigo.toLowerCase();
      const Poblacion = item.Poblacion.toLowerCase();
      const Nombre = item.Nombre.toLowerCase();
      const Direccion = item.Direccion.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        Codigo.indexOf(searchText) > -1 ||
        Poblacion.indexOf(searchText) > -1 ||
        Nombre.indexOf(searchText) > -1 ||
        Direccion.indexOf(searchText) > -1
      );
    },
    ...mapActions({
      createAddress: "addresses/addAddress",
      updateAddress: "addresses/updateAddress"
    }),
    ...mapActions("addresses", ["fetchAddresses"]),
    ...mapActions("countries", ["fetchCountries"]),
    async filtrarAPI() {
      if (this.loading || !this.paisCercano) return;
      this.loading = true;
      let filtro = {
        Pais: this.selectedAddress.Pais,
        Comunidad: this.Comunidad ? this.Comunidad : this.Comunidad_s,
        Provincia: this.Provincia ? this.Provincia : this.Provincia_s,
        Poblacion: this.selectedAddress.Poblacion
          ? this.selectedAddress.Poblacion
          : this.Poblacion_s,
        CodigoPostal: this.CodigoPostal_s
          ? this.CodigoPostal_s
          : this.selectedAddress.CodigoPostal
      };

      let res = await fetch(
        this.$apiRoute + "Localizacion/?" + queryString.stringify(filtro),
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("_token")
          }
        }
      );
      let response = await res.json();

      /*if (response.Comunidades.length === 0) {
        this.loading = false;
        return;
      }*/

      this.Provincias = response.Provincias;
      this.Poblaciones = response.Poblaciones;
      this.CodigosPostales = response.Cp;
      this.Comunidades = response.Comunidades;

      if (this.paisCercano) {
        if (this.Comunidades.length === 1) this.Comunidad = this.Comunidades[0];
        if (this.Provincias.length === 1) this.Provincia = this.Provincias[0];
        if (this.Poblaciones.length === 1)
          this.selectedAddress.Poblacion = this.Poblaciones[0];
        if (this.CodigosPostales.length === 1)
          this.selectedAddress.CodigoPostal = this.CodigosPostales[0];
      }

      this.loading = false;
    },
    async create(address) {
      if (address.Id > 0) {
        await this.updateAddress(address);
      } else {
        let addressNew = await this.createAddress(address);
      }
      this.fetchAddresses(this.filtro);
    },
    focusNombre() {
      let textBox = this.$refs.NombreApellido;
      setTimeout(function() {
        textBox.focus();
      }, 500);
    },
    validate() {
      if (this.$refs.form.validate()) {
        if (this.esDesdeServicio) {
          this.create(this.selectedAddress);
        } else {
          this.$emit("processAddress", this.selectedAddress);
        }
      }
    },
    async preCargarSelects() {
      if (this.selectedAddress.CodigoPostal) {
        this.CodigosPostales.push(this.selectedAddress.CodigoPostal);
      }
      if (this.selectedAddress.Poblacion) {
        let temp = { Poblacion: this.selectedAddress.Poblacion };
        this.Poblaciones.push(temp);
      }
    },
    estableSituacion() {
      if (this.selectedAddress == null) {
        this.selectedAddress = {
          Id: null,
          Codigo: null,
          Nombre: "",
          Direccion: "",
          TipoDireccion: "c/",
          NumeroDireccion: 0,
          CodigoPostal: "",
          Pais: "ESPAÑA",
          Poblacion: "",
          Provincia: "",
          PisoDireccion: 0,
          Nombre2: "",
          MasDatos: "",
          Telefono: "",
          Email: "",
          Observacion: "",
          Movil: "",
          Latitud: 0,
          Longitud: 0,
          Nif: "",
          Pointer: 0,
          Defecto: false,
          AvisoEmailRemitente: false,
          AvisoSmsRemitente: false,
          AvisoEmailDestino: false,
          AvisoSmsDestino: false
        };
      }
      if (
        this.selectedAddress.CodigoPostal &&
        this.selectedAddress.CodigoPostal.length > 2 &&
        this.CodigosPostales.length === 0
      ) {
        this.filtrarAPI();
      }
      if (this.selectedAddress.id > 0) {
        this.title = "Actualizar dirección";
        this.direccionSubmit = "Actualizar";
      } else {
        this.title = "Crear nueva dirección";
        this.direccionSubmit = "Guardar";
      }
      if (this.esDesdeServicio === true) {
        this.$emit("estableceDireccion", this.selectedAddress);
      }
    },
    limpiarDireccion() {
      this.loading = true;
      this.Provincia = null;
      this.Comunidad = null;
      this.selectedAddress.CodigoPostal = null;
      //this.selectedAddress.Pais = "ESPAÑA";
      this.selectedAddress.Poblacion = null;
      this.filtrarAPI();
      this.loading = false;
    },
    clear() {
      this.selectedAddress = {
        id: null,
        Codigo: null,
        Nombre: "",
        Direccion: "",
        TipoDireccion: "c/",
        NumeroDireccion: 0,
        CodigoPostal: "",
        Pais: "ESPAÑA",
        Poblacion: "",
        Provincia: "",
        PisoDireccion: 0,
        Nombre2: "",
        MasDatos: "",
        Telefono: "",
        Email: "",
        Observacion: "",
        Movil: "",
        Latitud: 0,
        Longitud: 0,
        Nif: "",
        Pointer: 0,
        Defecto: false,
        AvisoEmailRemitente: false,
        AvisoSmsRemitente: false,
        AvisoEmailDestino: false,
        AvisoSmsDestino: false
      };
      this.Provincia = null;
      this.Comunidad = null;
    }
  },
  computed: {
    ...mapState("countries", ["paises"]),
    ...mapGetters("addresses", ["addresses", "defecto"]),
    paisCercano: function() {
      if (this.selectedAddress.Pais === "ESPAÑA") return true;
      if (this.selectedAddress.Pais === "ANDORRA") return true;
      if (this.selectedAddress.Pais === "PORTUGAL") return true;
      return false;
      this.$forceUpdate();
    }
  },
  watch: {
    direccion: function(newVal, oldVal) {
      this.selectedAddress = newVal;
    },
    Poblacion_s: function(newVal, oldVal) {
      if (newVal === "") this.limpiarDireccion();
      else this.filtrarAPI();
    },
    CodigoPostal_s: function(newVal, oldVal) {
      this.filtrarAPI();
    },
    Comunidad_s: function(newVal, oldVal) {
      this.filtrarAPI();
    },
    Provincia_s: function(newVal, oldVal) {
      this.filtrarAPI();
    }
  }
};
</script>

<style>
.center {
  width: 500px;
  margin: 24px auto 44px auto !important;
}
</style>
